<!--
 * @Author: 忠于自己 429022021@qq.com
 * @Date: 2025-07-12 11:10:40
 * @LastEditors: 忠于自己 429022021@qq.com
 * @LastEditTime: 2025-07-17 15:58:01
 * @FilePath: \duilvpcbase\src\views\originality\children\createQE\components\viewExtrinsicFactorsNode.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <div class="node-state"
             style="margin-left:1%;margin-bottom:0.5%;margin-top: 0.5%;">
          <div class="item-state"
               style="padding-left: 1%;padding-bottom:0.5%;padding-bottom:0.5%;width:700px;white-space:normal;"
               v-for="radioData of extrinsicFactorsDataArr"
               :key="radioData.nodeName">
            <span>{{radioData.nodeName}}</span><br>
            <div class="demo-image">
              <div class="block"
                   v-for="(url,index) of radioData.picArr"
                   :key="index">
                <el-image style="width: 200px; height: 200px"
                          :src="url"
                          :fit="'scale-down'"
                          :preview-src-list="radioData.picArr"></el-image>
              </div>
            </div>
            <template>
              <el-radio-group v-model="radioData.nodeState"
                              text-color="#626aef"
                              size="small"
                              fill="rgb(239, 240, 253)"
                              style="margin-bottom:1%;margin-top: 0.5%;">
                <el-radio border
                          disabled
                          :label=1>良好</el-radio>
                <el-radio border
                          disabled
                          :label=2>预警</el-radio>
                <el-radio border
                          disabled
                          :label=3>异常</el-radio>
              </el-radio-group>
            </template>
            <div class="create-title-p"
                 style="margin:0px;">
              <input type="text"
                     disabled
                     v-model="radioData.remark" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'viewExtrinsicFactorsNode',
  props: ['oldExtrinsicFactorsDataArr'],
  watch: {
    oldExtrinsicFactorsDataArr (newValue) {
      this.extrinsicFactorsDataArr = newValue;
    },
  },
  data () {
    return {
      type: '',
      //nodeState 1-良好 2-预警 3-异常
      extrinsicFactorsDataArr: this.oldExtrinsicFactorsDataArr
    }
  },
  components: {

  },
  computed: {

  },
  methods: {
    init () {
      this.type = this.$route.query.type
    },
    created () {
      this.init()
    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.init();
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
  },
}
</script>

<style scoped>

.demo-image {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;
  align-items: flex-start;
}

.block {
  flex: 0 0 auto;
}

</style>
